export const baseSwatches = {
	'Black': 'https://cdn.shopify.com/s/files/1/1147/9910/files/base-color-black.png',
	'Blue Clear': 'https://cdn.shopify.com/s/files/1/1147/9910/files/base-color-blue-clear.png',
	'Blue Tortoise': 'https://cdn.shopify.com/s/files/1/1147/9910/files/base-color-blue-tortoise.png',
	'Crystal Clear': 'https://cdn.shopify.com/s/files/1/1147/9910/files/base-color-crystal-clear.png',
	'Pink Clear': 'https://cdn.shopify.com/s/files/1/1147/9910/files/base-color-pink-clear.png',
	'Tortoise': 'https://cdn.shopify.com/s/files/1/1147/9910/files/base-color-tortoise.png',
};

export const lensSwatches = [
	'black',
	'brown',
	'green',
	'silver-reflective',
	'pink-reflective',
	'blue-reflective',
	'green-reflective',
];

export const frameWidths = ['Extra-Narrow', 'Narrow', 'Medium', 'Wide'];

export const generateSizingClass = name => {
	switch (name) {
		case 'The Cedro':
			return 'Extra-Narrow';
		case 'The Serra':
			return 'Extra-Narrow';
		case 'The Twain':
			return 'Extra-Narrow';
		case 'The Otero':
			return 'Narrow';
		case 'The Larkin':
			return 'Narrow';
		case 'The Reese':
			return 'Narrow';
		case 'The Casper':
			return 'Medium';
		case 'The Soto':
			return 'Medium';
		case 'The Finley':
			return 'Medium';
		case 'The Ella':
			return 'Medium';
		case 'The Kirby':
			return 'Wide';
		case 'The Otis':
			return 'Wide';
		case 'The Wanda':
			return 'Wide';
		default:
			return '';
	}
};

export const generateAgeRange = name => {
	switch (name) {
		case 'The Cedro':
			return '5-9yrs';
		case 'The Serra':
			return '5-9yrs';
		case 'The Otero':
			return '8-12yrs';
		case 'The Twain':
			return '9-Adult';
		case 'The Larkin':
			return '9-Adult';
		default:
			return '5-9yrs';
	}
};

export const getCollectionQueryParam = collectionName => {
	if (collectionName.includes('Kid')) {
		return 'kids=true';
	}
	if (collectionName.includes('Men')) {
		return 'men=true';
	}
	if (collectionName.includes('Women')) {
		return 'women=true';
	}
};

export function glowAnimation(querySelector = '.plp-grid .product-card', callback = () => {}) {
	return setInterval(() => {
		[...document.querySelectorAll(querySelector)].forEach(v => {
			v.classList.toggle('active');
		});
		callback();
	}, 3000);
}

export const getProductsWithAvailableVariant = ({
	products,
	selectedFrameShape,
	availabilityPropertyName = 'availableForSale',
}) => {
	return products.filter(product => {
		const selectedVariant = product.variants.find(variant => variant.title === selectedFrameShape);
		return selectedVariant && selectedVariant[availabilityPropertyName];
	});
};

export const ActiveFrameShape = {
	get: () => localStorage.getItem('activeFrameShape') ?? 'Larkin',
	set: frameShape => {
		try {
			localStorage.setItem('activeFrameShape', frameShape);
			return true;
		} catch (error) {
			console.error(error);
			return false;
		}
	},
};
